import { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { CustomForm, CustomModal } from "../../components";
import {
  useLoginMutation,
  useFetchProfilesQuery,
  useAddUserMutation,
  useVerifyOtpMutation,
} from "../../store/api/apiSlice";
import { useAuth } from "../../store/context/authContext";
import "../../styles/auth.css";
import { Button, Image, Input, SectionHeading } from "../../ui";
import Updsteprofil from "../forumlist/updsteprofil";
import Membership from "../../components/Membership/Membership";
const Login = () => {
  const { refetch: refetchProfiles } = useFetchProfilesQuery();

  const [verifyOtp] = useVerifyOtpMutation();
  const { logging } = useAuth();
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const emailRef = useRef();
  const passwordRef = useRef();
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => {
    setIsModalOpen(false);
    setStep(1);
    setEmail("");
    setOtp("");
    setNewPassword("");
    setConfirmPassword("");
  };
  const [login, { isSuccess }] = useLoginMutation();
  const secretKey = process.env.REACT_APP_SECRET_KEY;
  const baseUrl = process.env.REACT_APP_SERVER_URL;
  const [loading, setLoading] = useState(false);
  const [emailLoading, setEmailLoading] = useState(false);
  const [otpLoading, setOtpLoading] = useState(false);
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [proceedLoading, setProceedLoading] = useState(false);
  const [verifiedd, setVerified] = useState(true);

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleNavigateToDashboard = () => {
    setProceedLoading(true);
    navigate("/", { replace: true });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const email = emailRef.current.value;
    const password = passwordRef.current.value;
    setEmail(email);

    if (!validateEmail(email)) {
      toast.error("Please enter a valid email!");
      setLoading(false);
      return;
    }

    if (!password) {
      toast.error("Password is required!");
      setLoading(false);
      return;
    }

    try {
      const result = await login({ email, password }).unwrap();
      localStorage.clear();

      const createdAtDate = new Date(result.createdAt);
      const currentDate = new Date();
      const tenDaysAgo = new Date(
        currentDate.setDate(currentDate.getDate() - 10)
      );

      if (createdAtDate < tenDaysAgo && !result.isPaid) {
        toast.error(
          "Your trial is ended. Please purchase the membership to get full access."
        );
        navigate("/membership", { replace: true });
        return;
      } else if (
        result.is_admin ||
        result.isPaid ||
        (createdAtDate > tenDaysAgo && !result.isPaid)
      ) {
        toast.success("Login successful!");
        localStorage.setItem("token", JSON.stringify(result));

        const tokenData = localStorage.getItem("token");
        const xAuthToken = tokenData ? JSON.parse(tokenData).token : null;

        const response = await fetch(`${baseUrl}/api/auth/user-profile`, {
          method: "GET",
          headers: {
            "secret-key": secretKey,
            "x-auth-token": xAuthToken,
            "Content-Type": "application/json",
          },
        });

        if (response.ok) {
          const data = await response.json();

          localStorage.setItem("user", JSON.stringify(data.user));

          const storedToken = localStorage.getItem("token");
          const storedUser = localStorage.getItem("user");
          // const expirationTime = Date.now() + 6 * 60 * 60 * 1000;
          // const expirationTime = Date.now() + 10 * 1000; // 10 seconds in milliseconds
          // localStorage.setItem("tokenExpiration", expirationTime);
          if (storedToken && storedUser) {
            if (data.user.profile_update) {
              logging();
              navigate("/", { replace: true });
            } else {
              setStep(4);
              setVerified(false);
            }
          } else {
            throw new Error(
              "Failed to save token or user data in localStorage."
            );
            toast.error("hello");
          }
        } else {
          throw new Error("Failed to fetch user profile");
        }
      }
    } catch (error) {
      console.log("error", error.data?.message);
      if (error.data?.message === "Your account is not verified.") {
        setStep(6);
        openModal(true);
        setVerified(false);
      }
      if (error && error.data && error.data.message) {
        toast.error(error.data?.message);
      } else {
        toast.error("An unexpected error occurred. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };
  const handleSubmitEmail = async () => {
    setEmailLoading(true);
    if (!validateEmail(email)) {
      toast.error("Please enter a valid email.");
      setEmailLoading(false);
      return;
    }
    try {
      const response = await fetch(`${baseUrl}/api/auth/send-otp`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "secret-key": secretKey,
        },
        body: JSON.stringify({ email }),
      });
      const data = await response.json();
      if (data.success) {
        toast.success("OTP sent to your email.");
        setStep(2);
        setEmailLoading(false);
      } else {
        toast.error(data.msg || "Error sending OTP.");
        setEmailLoading(false);
      }
    } catch (error) {
      toast.error("Failed to send OTP.");
      setEmailLoading(false);
    }
  };

  const handleSubmitOtp = async () => {
    setOtpLoading(true);
    const password = passwordRef.current?.value || "";
    const email = emailRef.current?.value || "";
    if (!otp) {
      toast.error("Please enter the OTP.");
      setOtpLoading(false);
      return;
    }
    try {
      const response = await fetch(`${baseUrl}/api/auth/verify-otp`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "secret-key": secretKey,
        },
        body: JSON.stringify({ email, otp }),
      });
      const data = await response.json();
      if (data.success) {
        toast.success("OTP verified successfully.");
        if (!verifiedd) {
          await verifyOtp({ email, otp }).unwrap();
          const data = await login({ email, password }).unwrap();
          localStorage.setItem("token", JSON.stringify(data));
          const profileData = await refetchProfiles().unwrap();

          localStorage.setItem("user", JSON.stringify(profileData?.user));
          closeModal();
          setStep(4);
        } else {
          setStep(3);
        }
        setOtpLoading(false);
      } else {
        toast.error(data.message || "Invalid OTP.");
        setOtpLoading(false);
      }
    } catch (error) {
      toast.error("Failed to verify OTP.");
      setOtpLoading(false);
    }
  };

  const handleChangePassword = async () => {
    if (!newPassword || newPassword !== confirmPassword) {
      toast.error("Passwords do not match or are empty.");
      return;
    }
    try {
      const payload = {
        email,
        otp,
        new_password: newPassword,
      };

      const response = await fetch(`${baseUrl}/api/auth/reset-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "secret-key": secretKey,
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (data.success) {
        toast.success("Password reset successfully.");
        closeModal();
      } else {
        toast.error(data.message || "Failed to reset password.");
      }
    } catch (error) {
      toast.error("Failed to reset password.");
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    const user = localStorage.getItem("user");

    if (isSuccess && token && user) {
      navigate("/");
      closeModal();
    }
  }, [isSuccess, navigate]);

  return (
    <div className="authWrapper">
      <CustomModal isOpen={isModalOpen} onClose={closeModal}>
        {step === 1 && (
          <>
            <SectionHeading>Forgot Your Password</SectionHeading>
            <p style={{ marginBottom: "0px", paddingBottom: "30px" }}>
              Please enter your email to receive an OTP
            </p>
            <p className="fieldWrapper">
              <Input
                label="Email"
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </p>
            <Button onClick={handleSubmitEmail} loading={emailLoading}>
              {" "}
              Submit
            </Button>
          </>
        )}

        {step === 2 && (
          <>
            <SectionHeading>Enter OTP</SectionHeading>
            <p>Please enter the OTP sent to your email.</p>
            <p className="fieldWrapper">
              <Input
                label="OTP"
                type="text"
                id="otp"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
              />
            </p>
            <div className="Resend_button">
              <Button onClick={handleSubmitOtp} loading={otpLoading}>
                Submit OTP
              </Button>
              <Button
                outlined
                onClick={handleSubmitEmail}
                loading={emailLoading}
              >
                Resend OTP
              </Button>
            </div>
          </>
        )}

        {step === 3 && (
          <>
            <SectionHeading>Change Your Password</SectionHeading>
            <p className="fieldWrapper">
              <Input
                label="New Password"
                type="password"
                id="newPassword"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
            </p>
            <p className="fieldWrapper">
              <Input
                label="Confirm New Password"
                type="password"
                id="confirmPassword"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
            </p>
            <Button onClick={handleChangePassword}>Change Password</Button>
          </>
        )}
      </CustomModal>

      {step === 6 && (
        <CustomModal isOpen={isModalOpen} onClose={closeModal}>
          <div style={{ position: "relative" }}>
            <SectionHeading>Verify OTP</SectionHeading>
          </div>

          <p className="fieldWrapper">
            <Input label="Email" type="text" value={email} readOnly />
          </p>
          <p className="fieldWrapper">
            <Input
              label="OTP"
              type="text"
              id="otp"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
            />
          </p>
          <div className="Resend_button">
            <Button onClick={handleSubmitOtp} loading={otpLoading}>
              Submit
            </Button>

            <Button outlined onClick={handleSubmitEmail} loading={emailLoading}>
              Resend OTP
            </Button>
          </div>
        </CustomModal>
      )}
      {!(step === 4 || step === 5) || verifiedd ? (
        <>
          <div
            className="title-section"
            style={{ display: "flex", alignItems: "center" }}
          >
            <Image
              style={{
                width: "60px",
                height: "60px",
                marginRight: "20px",
              }}
              path="/images/headericon.png"
              alt="Logo"
            />
            <h2 className="pb-0">College Sports Fan Association</h2>
          </div>
          <div className="row formWrapper">
            <CustomForm
              onSubmit={handleSubmit}
              className="col-5 mx-auto Login-form"
            >
              <p className="fieldWrapper pt-3" style={{ color: "#203864" }}>
                <h3>Sign In</h3>
              </p>
              <p className="fieldWrapper">
                <Input
                  placeholder="Email or Username"
                  label="Email"
                  type="text"
                  id="email"
                  ref={emailRef}
                />
              </p>
              <p className="fieldWrapper">
                <Input
                  label="Password"
                  type="password"
                  id="password"
                  ref={passwordRef}
                />
              </p>
              <div className="authLinksWrapper_login">
                <p style={{ margin: 0 }}>
                  Don’t have an account? <Link to="/signup">Sign Up</Link>
                </p>
                <Link onClick={openModal} style={{ margin: 0 }}>
                  Forgot Password?
                </Link>
              </div>
              <br />
              <p className="buttonWrapper">
                <Button type="submit" loading={loading}>
                  Login
                </Button>
              </p>
            </CustomForm>
          </div>
        </>
      ) : null}
      {step === 4 && (
        <div className=" mb-2">
          <Updsteprofil signupMode="true" setStep={setStep} />
        </div>
      )}
      {step === 5 && (
        <div style={{ width: "-webkit-fill-available" }}>
          <Membership signupMode="true" />
          <div className="text-center mt-4">
            <Button
              onClick={handleNavigateToDashboard}
              loading={proceedLoading}
            >
              Skip For Now
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Login;
